"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'plant-nursery',
  path: '/plant-nursery',
  meta: {
    expanded: false,
    title: 'Viveiro de mudas',
    iconClass: 'icon-ic_fazenda',
    requiresAuth: true
  },
  children: [{
    name: 'plant-nursery-dashboard',
    path: '/plant-nursery/dashboard',
    icon: 'icon-ic_dashboard',
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-lots',
    path: '/plant-nursery',
    icon: 'icon-ic_lista',
    meta: {
      title: 'Lotes',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-create-lot',
    path: '/plant-nursery/create-lot',
    icon: 'icon-ic_adicionar',
    meta: {
      title: 'Criar Lote',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-graft',
    path: '/plant-nursery/graft',
    icon: 'icon-ic_processos',
    meta: {
      title: 'Enxertia',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-partial-graft',
    path: '/plant-nursery/partial-graft',
    icon: 'icon-ic_processos',
    meta: {
      title: 'Enxertia Parcial',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-graft-success-rate',
    path: '/plant-nursery/graft-success-rate',
    icon: 'icon-ic_erro',
    meta: {
      title: 'Índice de Pegamento',
      requiresAuth: true
    }
  },
  // {
  //   name: 'plant-nursery-merge-lots',
  //   path: '/plant-nursery/merge-lots',
  //   icon: 'icon-ic_agrupar',
  //   meta: { title: 'Juntar Lotes', requiresAuth: true }
  // },
  {
    name: 'plant-nursery-mortality',
    path: '/plant-nursery/mortality',
    icon: 'icon-ic_erro',
    meta: {
      title: 'Mortalidades',
      requiresAuth: true
    }
  },
  // {
  //   name: 'plant-nursery-transfer',
  //   path: '/plant-nursery/transfer',
  //   icon: 'icon-ic_transferencia',
  //   meta: { title: 'Transferir', requiresAuth: true }
  // },
  {
    name: 'plant-nursery-move-lot',
    path: '/plant-nursery/move-lot',
    icon: 'icon-ic_transferencia',
    meta: {
      title: 'Mover',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-dispatch',
    path: '/plant-nursery/dispatch',
    icon: 'icon-ic_entrega',
    meta: {
      title: 'Expedição',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-sectors',
    path: '/plant-nursery/sectors',
    icon: 'icon-ic_mapa',
    meta: {
      title: 'Setores',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-varieties',
    path: '/plant-nursery/varieties',
    icon: 'icon-ic_classificacao',
    meta: {
      title: 'Variedades',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-customers',
    path: '/plant-nursery/customers',
    icon: 'icon-ic_operadores',
    meta: {
      title: 'Clientes',
      requiresAuth: true
    }
  }, {
    name: 'plant-nursery-contracts',
    path: '/plant-nursery/contracts',
    icon: 'icon-ic_pdf1',
    meta: {
      title: 'Contratos',
      requiresAuth: true
    }
  }]
};